import { render, staticRenderFns } from "./SeatsCard.vue?vue&type=template&id=564d9898&scoped=true&lang=html&"
import script from "./SeatsCard.vue?vue&type=script&lang=js&"
export * from "./SeatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d9898",
  null
  
)

export default component.exports